// Master list of Tamil Nadu districts as spelled in the SC/ST Habitations sheet
// (source of truth for the district dropdown on the dashboard).
// Any variant name is mapped back to this list.

import HABITATION_METRICS from './habitationMetrics';

// The SC/ST habitations sheet doesn't include CHENNAI (no rural habitations),
// but the ranking / district-filter must still recognise it since other
// datasets (FRA, drop-outs, TIME, ADW hostels) do carry Chennai data.
const EXTRA_CANONICAL = ['CHENNAI'];
const CANONICAL = [
  ...Object.keys(HABITATION_METRICS.districts || {}).map(d => d.trim().toUpperCase()),
  ...EXTRA_CANONICAL,
];
const CANONICAL_SET = new Set(CANONICAL);

// Manual aliases — variants that don't match the canonical spelling directly.
const ALIASES = {
  'KANYAKUMARI':      'KANNIYAKUMARI',
  'NILGIRIS':         'THE NILGIRIS',
  'THIRUCHIRAPALLI':  'TIRUCHIRAPPALLI',
  'THIRUCHIRAPPALLI': 'TIRUCHIRAPPALLI',
  'THIRUVALLUR':      'TIRUVALLUR',
  'THIRUVANNAMALAI':  'TIRUVANNAMALAI',
  'TIRUPATTUR':       'TIRUPATHUR',
  'TUTICORIN':        'THOOTHUKKUDI',
  'VILUPPURAM':       'VILLUPURAM',
  'THIRUVARUR':       'TIRUVARUR',
  'THIRUNELVELI':     'TIRUNELVELI',
  'THIRUPPUR':        'TIRUPPUR',
};

// Normalise any district name to the canonical spelling used on the dashboard.
// Returns null when the input can't be matched — caller can drop such rows to
// avoid phantom entries (e.g. rows where 42 districts appear because the same
// district was spelled two different ways).
export const canonicalDistrict = (raw) => {
  if (!raw) return null;
  const up = String(raw).trim().toUpperCase().replace(/\s+/g, ' ');
  if (CANONICAL_SET.has(up)) return up;
  if (ALIASES[up]) return ALIASES[up];
  // Try dropping "THE " prefix
  const noThe = up.replace(/^THE\s+/, '');
  if (CANONICAL_SET.has(noThe)) return noThe;
  const withThe = 'THE ' + up;
  if (CANONICAL_SET.has(withThe)) return withThe;
  return null;
};

export const CANONICAL_DISTRICTS = CANONICAL;
export default canonicalDistrict;
